module.exports = __webpack_public_path__ + "img/d624844.jpg";